import React from 'react';
import { Container } from 'semantic-ui-react';
import { Route, Switch, Redirect } from 'react-router-dom';
import {
  Buildings,
  ChemicalProduct,
  Forbidden,
  Inventory,
  JobManagement,
  BatchUpdate,
  Home,
  Error,
  AccessRequest,
  RequiredCompetency,
  Activity,
  Action,
} from '../../routes';
import NotificationBarComponent from '../common/NotificationBarComponent';
import { initSelectors } from '../../behavior/init';
import CompetencyToExpireNotificationBarComponent from '../common/CompetencyToExpireNotificationBarComponent';
import useUser from '@behavior/init/getUserV2';

const ContentContainer = () => {
  const { user } = useUser();
  const isChemicalProductSdsFileDownload =
    ChemicalProduct.children.chemicalProductSdsFileDownlaod.matchRouteRegex.test(location.pathname);

  return (
    <Container id="app-main-container">
      <Switch>
        <Route
          exact
          key="accessRequest"
          path={AccessRequest.route()}
          component={AccessRequest.component}
        />
        <Route
          exact
          key="missing-courses"
          path={RequiredCompetency.route()}
          component={RequiredCompetency.component}
        />

        {!isChemicalProductSdsFileDownload && initSelectors.isMissingCompetency(user) && (
          <Redirect to={RequiredCompetency.route()} />
        )}
        <Route exact key="home" path={Home.route()} component={Home.component} />
        <Route
          exact
          key="error-generic"
          path={Error.children.generic.route()}
          component={Error.children.generic.component}
        />
        <Route
          exact
          key="error-with-code"
          path={Error.children.withCode.route()}
          component={Error.children.withCode.component}
        />
        <Route
          exact
          key="inventory-overview"
          path={Inventory.children.inventoryOverview.route()}
          component={Inventory.children.inventoryOverview.component}
        />
        <Route
          exact
          key="inventory-history-overview"
          path={Inventory.children.inventoryHistoryOverview.route()}
          component={Inventory.children.inventoryHistoryOverview.component}
        />
        <Route
          exact
          key="inventory-create"
          path={Inventory.children.inventoryCreate.route()}
          component={Inventory.children.inventoryCreate.component}
        />
        <Route
          exact
          key="inventory-details"
          path={Inventory.children.inventoryDetails.route()}
          component={Inventory.children.inventoryDetails.component}
        />
        <Route
          exact
          key="inventory-details-mobile"
          path={Inventory.children.inventoryDetailsMobile.route()}
          component={Inventory.children.inventoryDetailsMobile.component}
        />
        <Route
          exact
          key="inventory-details-qr-short"
          path={Inventory.children.inventoryDetailsMobile.route()}
          component={Inventory.children.inventoryDetailsMobile.component}
        />
        <Route
          exact
          key="inventory-history-details"
          path={Inventory.children.inventoryHistoryDetails.route()}
          component={Inventory.children.inventoryHistoryDetails.component}
        />
        <Route
          exact
          key="chemical-product-overview"
          path={ChemicalProduct.children.chemicalProductOverview.route()}
          component={ChemicalProduct.children.chemicalProductOverview.component}
        />
        <Route
          exact
          key="chemical-product-history-overview"
          path={ChemicalProduct.children.chemicalProductHistoryOverview.route()}
          component={ChemicalProduct.children.chemicalProductHistoryOverview.component}
        />
        <Route
          exact
          key="chemical-product-create"
          path={ChemicalProduct.children.chemicalProductCreate.route()}
          component={ChemicalProduct.children.chemicalProductCreate.component}
        />
        <Route
          exact
          key="chemical-product-details"
          path={ChemicalProduct.children.chemicalProductDetails.route()}
          component={ChemicalProduct.children.chemicalProductDetails.component}
        />
        <Route
          exact
          key="chemical-product-sds-file-downlaod"
          path={ChemicalProduct.children.chemicalProductSdsFileDownlaod.route()}
          component={ChemicalProduct.children.chemicalProductSdsFileDownlaod.component}
        />
        <Route
          exact
          key="chemical-product-history-details"
          path={ChemicalProduct.children.chemicalProductHistoryDetails.route()}
          component={ChemicalProduct.children.chemicalProductHistoryDetails.component}
        />
        <Route exact key="forbidden" path={Forbidden.route()} component={Forbidden.component} />
        <Route exact key="jobs" path={JobManagement.route()} component={JobManagement.component} />
        <Route
          exact
          key="buildings-search"
          path={Buildings.children.search.route()}
          component={Buildings.children.search.component}
        />
        <Route
          exact
          key="buildings-summary-by-id"
          path={Buildings.children.summaryById.route()} // RRA-945. support by id due to old urls and edms documents
          component={Buildings.children.summaryById.component}
        />
        <Route
          exact
          key="buildings-summary-by-num"
          path={Buildings.children.summaryByNum.route()}
          component={Buildings.children.summaryByNum.component}
        />
        <Route
          exact
          key="batch-update"
          path={BatchUpdate.route()}
          component={BatchUpdate.component}
        />
        <Route
          exact
          key="activity-create"
          path={Activity.children.activityCreate.route()}
          component={Activity.children.activityCreate.component}
        />
        <Route
          exact
          key="activity-details"
          path={Activity.children.activityDetails.route()}
          component={Activity.children.activityDetails.component}
        />
        <Route
          exact
          key="activity-overview"
          path={Activity.children.activityOverview.route()}
          component={Activity.children.activityOverview.component}
        />
        <Route
          exact
          key="actions-details"
          path={Action.children.allActions.route()}
          component={Action.children.allActions.component}
        />
        <Route
          exact
          key="action-details"
          path={Action.children.actionDetails.route()}
          component={Action.children.actionDetails.component}
        />
        <Redirect to={Error.children.withCode.route(404)} />
      </Switch>
      <NotificationBarComponent />
      <CompetencyToExpireNotificationBarComponent />
    </Container>
  );
};

export default React.memo(ContentContainer);
